import { AppEnvironment } from './environment.model';

/** DEVELOPMENT configuration — applied by the `development` build configuration. */
export const environment: AppEnvironment = {
  production: false,
  useEmulators: false,
  firebaseConfig: {
  
    apiKey: 'AIzaSyBFYjw1QLKdAHSRCPfecEubHCWMi6SHCAc',
    authDomain: 'parkingless-dev-6a8a1.firebaseapp.com',
    projectId: 'parkingless-dev-6a8a1',
    storageBucket: 'parkingless-dev-6a8a1.appspot.com',
    messagingSenderId: '535312796497',
    appId: '1:535312796497:web:7525d5f48f7faa239d6170',
  /*
   apiKey: 'AIzaSyA-_J5JBNbfolwWybMJl1008wRNeWBrRxM',
    authDomain: 'parkingless-578ed.firebaseapp.com',
    projectId: 'parkingless',
    storageBucket: 'parkingless.appspot.com',
    messagingSenderId: '946929600030',
    appId: '1:946929600030:web:cd76d39d4a3c14e046900f',
    */
  },
  // Set from the reCAPTCHA Enterprise key for the parkingless-dev-6a8a1 web app (docs/SECURITY_AUDIT.md, F12).
  appCheck: {
    recaptchaEnterpriseSiteKey: '6LdXn8ItAAAAAMd8-u9vLNtQmn4SLDXgt5jYqGqd',
  },
  paypal: {
    clientId: 'AeBrF9hPQovyHXQv5z00YdgJPJHdEXibImt50hbDwlUm89hLZDzRDupRIOzKkJN7sr156sOFU4xFn92z',
    currency: 'EUR',
    intent: 'CAPTURE',
  },
  googleMaps: {
    apiKey: 'AIzaSyAkfKf4Fx5T4rGNHrgaHq7fwo_XGi8-MEI',
    libraries: ['places', 'visualization'],
  },
};
